// DashboardSidebar.js
import React from "react";
import {
  Drawer,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Typography,
  Button,
  Divider,
  Box,
} from "@mui/material";
import { Home, Person, Payment, DashboardCustomize } from "@mui/icons-material";
import { auth } from "../firebase";
import { useNavigate } from "react-router-dom";

const features = [
  { name: "Home", icon: <Home /> },
  { name: "User Management", icon: <Person /> },
  { name: "Trello Board Management", icon: <DashboardCustomize /> },
  { name: "Generate Payment", icon: <Payment /> },
  { name: "Sign Payment", icon: <Payment /> },
];

const DashboardSidebar = ({ selectedFeature, onSelectFeature, user }) => {
  const navigate = useNavigate();

  const handleLogout = async () => {
    try {
      await auth.signOut();
      navigate("/login");
    } catch (error) {
      alert("Logout failed: " + error.message);
    }
  };

  return (
    <Drawer
      variant="permanent"
      sx={{
        width: 240,
        flexShrink: 0,
        "& .MuiDrawer-paper": { width: 240, boxSizing: "border-box" },
      }}
    >
      {/* Sidebar Header */}
      <Box sx={{ p: 2, textAlign: "center" }}>
        <Typography variant="h6" fontWeight="bold">
          AppJingle PMS
        </Typography>
        {user && (
          <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
            Logged in as: <strong>{user.displayName || user.email}</strong>
          </Typography>
        )}
      </Box>

      <Divider />

      {/* Features List */}
      <List>
        {features.map((feature, index) => (
          <ListItem
            button
            key={index}
            onClick={() => onSelectFeature(feature.name)} // Correctly call the function
            selected={selectedFeature === feature.name}
          >
            <ListItemIcon>{feature.icon}</ListItemIcon>
            <ListItemText primary={feature.name} />
          </ListItem>
        ))}
      </List>

      <Divider />

      {/* Logout Button */}
      <Box sx={{ p: 2, textAlign: "center", marginTop: "auto" }}>
        <Button
          variant="contained"
          color="error"
          fullWidth
          onClick={handleLogout}
        >
          Logout
        </Button>
      </Box>
    </Drawer>
  );
};

export default DashboardSidebar;
